import { CardTypeConfig } from '../../interfaces/card-type-config';

export const DANKORT_CARD_TYPE_NAME = 'dankort';

export const DANKORT_CARD_TYPE_NAME_CONFIG: CardTypeConfig = {
    niceType: 'Dankort',
    type: DANKORT_CARD_TYPE_NAME,
    patterns: [
        5019,
        4571
    ],
    gaps: [4, 8, 12],
    lengths: [16, 17, 18, 19],
    code: {
        name: 'CVV',
        size: 4
    }
};
